import { configureStore } from '@reduxjs/toolkit'
import languageReducer from '../component/slice/languageSlice'

export const store = configureStore({
  reducer: {
    webLanguage: languageReducer
  },
})